/* eslint-disable import/first */
/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { makeStyles } from '@material-ui/core/styles';
import { Layout } from '@roc/feature-app-core';
import { observer } from 'mobx-react-lite';
import { useHistory, useParams } from 'react-router';
import { useRoutes } from '../../hooks/useRoutes';
import { LeadDetailsComponent } from './leadDetailsComponent';
import { ExternalLeadStore } from 'libs/client-portal-shared/src/app/modules/companyProfile/stores/externalLeadStore';
import { useEffect, useState } from 'react';
import { useLeadsStore } from '../../hooks/useLeadsStore';
import { useNewLeadStore } from '../../hooks/useNewLeadStore';

const useStyles = makeStyles(theme => ({
  heading: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  button: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
    maxWidth: '250px',
  },
}));
interface ILeadDetails {
  id?: number;
  fromCadence?:Boolean;
  salesforceLeadStore: ExternalLeadStore;
  noteDialogContext?: 'default' | 'inline';
}

export const LeadDetails = observer(({ salesforceLeadStore, id,fromCadence = false, noteDialogContext = 'default' }: ILeadDetails) => {
  const { push } = useHistory();
  const { leadsDashboardRoutesConfig, possibleMatchesConfig, crmTaskDashboardRoutesConfig } = useRoutes();
  const { leadsStore } = useLeadsStore();
  const classes = useStyles();

  const { leadId: routeLeadId } = useParams<{ leadId: string }>();

  const leadId = id != null ? String(id) : routeLeadId;

  const [openModal, setOpenModal] = useState(false);
  const { newLeadStore } = useNewLeadStore();

  useEffect(() => {
    leadsStore.leadDetailsStore.reset();
  }, [leadId, leadsStore.leadDetailsStore]);

  const saveLead = () => {
    const isFormValid = salesforceLeadStore.editLeadDetailsFormStore.runFormValidationWithMessage();
    if (isFormValid) {
      salesforceLeadStore.editLeadDetails(leadId);
    }
  };

  const goToLeadsDashboard = () => {
    push(leadsDashboardRoutesConfig.leadsDashboard.url);
  };

  const handleBack = () => {
    if (fromCadence) return;

    push(
      newLeadStore.globalSearch
        ? possibleMatchesConfig.possibleMatches.url
        : newLeadStore.crmTaskDashboard
        ? crmTaskDashboardRoutesConfig.crmTaskDashboard.url
        : leadsDashboardRoutesConfig.leadsDashboard.url
    );
  };

  return (
    <Layout
      title="Lead Details"
      onBack={handleBack}
      maxWidth="xl"
    >
      <LeadDetailsComponent
        readOnly={false}
        leadId={leadId}
        salesforceLeadStore={salesforceLeadStore}
        onClose={goToLeadsDashboard}
        onSave={saveLead}
        noteDialogContext={noteDialogContext}
      />
    </Layout>
  );
});
